import { render } from "./textaPendulumOther.vue?vue&type=template&id=2c3455c6&scoped=true"
import script from "./textaPendulumOther.vue?vue&type=script&lang=js"
export * from "./textaPendulumOther.vue?vue&type=script&lang=js"

import "./textaPendulumOther.vue?vue&type=style&index=0&id=2c3455c6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3455c6"]])

export default __exports__